import DashboardReportTable from './DashboardReportTableContainer';

export default DashboardReportTable;
